export enum ESources {
  T2 = 't2',
  SRAVNI = 'sravni',
  AVITO = 'avito',
}

export const AFF_ID_PARTNER_MAP = {
  [ESources.SRAVNI]: '12181',
  [ESources.AVITO]: '12406',
  [ESources.T2]: '36970',
} as const;
